export const partition = (array, predicate)=>array.reduce((param, element)=>{
        let [predicateTrue, predicateFalse] = param;
        if (predicate(element)) {
            predicateTrue.push(element);
        } else {
            predicateFalse.push(element);
        }
        return [
            predicateTrue,
            predicateFalse
        ];
    }, [
        [],
        []
    ]);
export const unique = (array)=>Array.from(new Set(array));
